export default function (app) {
  app.controller('klChurnSurveyCtrl', [
    '$state',
    '$window',
    'klSubscriptionService',
    function ($state, $window) {
      $window.iframeLoadCounter = 0;
      this.close = function () {
        $state.params.onComplete();
      };

      $window.backWhenFinished = function () {
        if ($window.iframeLoadCounter < 1) {
          $window.iframeLoadCounter++;
        } else {
          $state.params.onComplete();
        }
      };
    },
  ]);
}
